import React from 'react';
import "../styles/Contact.css";
import { useTranslation } from 'react-i18next';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AnchorIcon from '@mui/icons-material/Anchor';

const phoneNumbers = [
  {
    label: "+90 (537) 649 78 13",
    href: "tel:+905376497813",
    whatsapp: "https://wa.me/905376497813",
  },
  {
    label: "+90 (541) 272 13 92",
    href: "tel:+905412721392",
    whatsapp: "https://wa.me/905412721392",
  },
];

const emails = [
  "info@anchmarmarine.com",
  "umutmursitoglu@outlook.com",
];

const Contact = () => {
  const { t } = useTranslation();

  return (
    <main className="contactPage">
      <section className="contactHero">
        <div>
          <h1>{t('contact.title')}</h1>
          <p>
            Survey, bakım, arıza tespiti ve mühendislik danışmanlığı için
            bizimle doğrudan iletişime geçebilirsiniz.
          </p>
        </div>
      </section>

      <section className="contactContent" aria-label="İletişim bilgileri">
        <article className="contactProfile">
          <div className="profileIcon">
            <AnchorIcon />
          </div>
          <h2>Umut Mürşitoğlu</h2>
          <p>{t('contact.engineer')}</p>

        </article>

        <div className="contactCards">
          <article className="contactCard">
            <PhoneInTalkIcon />
            <div>
              <h2>{t('contact.phone')}</h2>
              {phoneNumbers.map((phone) => (
                <p key={phone.label}>
                  <a href={phone.href}>{phone.label}</a>
                  <a className="inlineAction" href={phone.whatsapp} target="_blank" rel="noopener noreferrer">
                    WhatsApp
                  </a>
                </p>
              ))}
            </div>
          </article>

          <article className="contactCard">
            <MailOutlineIcon />
            <div>
              <h2>{t('contact.email')}</h2>
              {emails.map((email) => (
                <p key={email}>
                  <a href={`mailto:${email}`}>{email}</a>
                </p>
              ))}
            </div>
          </article>

          <article className="contactCard">
            <LocationOnIcon />
            <div>
              <h2>{t('contact.address')}</h2>
              <p>{t('contact.addressValue')}</p>
              <a
                className="mapLink"
                href="https://www.google.com/maps/search/?api=1&query=%C4%B0stanbul%20%C3%9Cmraniye"
                target="_blank"
                rel="noopener noreferrer"
              >
                Haritada Aç
              </a>
            </div>
          </article>
        </div>
      </section>
    </main>
  );
};

export default Contact;
